import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MaterialType } from '../models/material/material-type.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MaterialTypeService extends RequestService<MaterialType> {
  static PATH = '/material/type';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, MaterialTypeService.PATH, globalService.debugUrl);
  }

  uploadFileWithoutProgress(file: File) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.httpClient.post(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${MaterialTypeService.PATH}/upload`,
      formData,
    );
  }

  download() {
    return this.httpClient.post(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${MaterialTypeService.PATH}/download`,
      {},
      { responseType: 'blob' },
    );
  }
}
